import React, {  } from 'react';
// material
import {
    Stack,

    
    Container,
    Typography,

    
    Box
    
    ,
} from '@mui/material';
// components
import Page from '../../../components/Page';
import CheckCard from '../../../components/CheckCard';
import TikTokLinkAccount from './parameter/intégration/TiktokLinkAccount';
import FacebookLinkAccount from './parameter/intégration/FacebookLinkAccount';
import withAuthorization from '../../../withAuthorization';


function Parameter() {

    return (
        <Page title="Campagne">
            <Box>

                <Container sx={{ marginTop: { xs: 0 }, }}>
                    <CheckCard />
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" mb={2} >
                        <Typography variant="h3" gutterBottom>
                            Paramêtres
                        </Typography>
                    </Stack>
                    <Stack mb={4} direction='row' spacing={1}>
                        <Box sx={{ bgcolor: '#5E17EB', color: 'white', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1}>
                            <Typography variant='body2'>Intégration</Typography>
                        </Box>
                        <Box sx={{ bgcolor: '#f2f2f2', borderRadius: '30px', cursor: 'pointer' }} paddingX={2} paddingY={1}>
                            <Typography variant='body2'>Personnalisations</Typography>
                        </Box>
                    </Stack>



                    <Stack paddingTop={0} spacing={3}>
                        <TikTokLinkAccount />
                        <FacebookLinkAccount />
                    </Stack>
                </Container>
            </Box>

        </Page>
    );
}
export default withAuthorization(Parameter, "manage_marketing")
